// Use this file to export React client components (e.g. those with 'use client' directive) or other non-server utilities

export * from './lib/Analytics';
export * from './lib/constants';
export * from './lib/types';
export * from './lib/LoadTrackers';
export { TrackPageView } from './lib/tracker-components/TrackPageView';
export {
  TrackBlockImpression,
  type TrackBlockImpressionProps,
} from './lib/tracker-components/TrackBlockImpression';

export { TrackBlockClick } from './lib/tracker-components/TrackBlockClick';
export {
  collectDataForPassportAnalytics,
  type PassportAnalytics,
} from './lib/utils/collectDataForPassportAnalytics';
export {
  collectDataForPageBlokAnalytics,
  type PageBlokAnalytics,
} from './lib/utils/collectDataForPageBlokAnalytics';
export { insertPageType } from './lib/utils/insertPageType';
export { AnalyticsClickProvider } from './lib/AnalyticsClickProvider';
export {
  trackAmplitudeEvent,
  trackAmplitudeFormSubmittedError,
  trackAmplitudeQuizEvent,
} from './lib/amplitude/amplitude';
